/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminNotification,
  AdminNotificationBulkInput,
  AdminNotificationBulkResult,
  AdminNotificationUnreadCount,
  AdminNotifications,
  AdminNotificationsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Admin Notifications list
 */
export const adminNotifications = (
    params?: MaybeRefOrGetter<AdminNotificationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<AdminNotifications>(
      {url: `/notifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getAdminNotificationsQueryKey = (params?: MaybeRefOrGetter<AdminNotificationsParams>,) => {
    return [
    'notifications', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof adminNotifications>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<AdminNotificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotifications>>> = ({ signal }) => adminNotifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotifications>>, TError, TData>
}

export type AdminNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotifications>>>
export type AdminNotificationsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Admin Notifications list
 */

export function useAdminNotifications<TData = Awaited<ReturnType<typeof adminNotifications>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<AdminNotificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Archive the selected Admin Notifications
 */
export const archiveBulkAdminNotifications = (
    adminNotificationBulkInput: MaybeRefOrGetter<AdminNotificationBulkInput>,
 signal?: AbortSignal
) => {
      adminNotificationBulkInput = toValue(adminNotificationBulkInput);

      return axiosClient<AdminNotificationBulkResult>(
      {url: `/notifications/archive-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminNotificationBulkInput, signal
    },
      );
    }




export const getArchiveBulkAdminNotificationsMutationKey = () => ['archiveBulkAdminNotifications'] as const;

export const getArchiveBulkAdminNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveBulkAdminNotifications>>, TError,ArchiveBulkAdminNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveBulkAdminNotifications>>, TError,ArchiveBulkAdminNotificationsMutationVariables, TContext> => {

const mutationKey = getArchiveBulkAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveBulkAdminNotifications>>, ArchiveBulkAdminNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  archiveBulkAdminNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveBulkAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof archiveBulkAdminNotifications>>>
    export type ArchiveBulkAdminNotificationsMutationBody = AdminNotificationBulkInput
    export type ArchiveBulkAdminNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ArchiveBulkAdminNotificationsMutationVariables = {data: AdminNotificationBulkInput}

    /**
 * @summary Archive the selected Admin Notifications
 */
export const useArchiveBulkAdminNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveBulkAdminNotifications>>, TError,ArchiveBulkAdminNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveBulkAdminNotifications>>,
        TError,
        ArchiveBulkAdminNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveBulkAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete all Admin Notifications
 */
export const destroyAllAdminNotifications = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/notifications/destroy-all`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAllAdminNotificationsMutationKey = () => ['destroyAllAdminNotifications'] as const;

export const getDestroyAllAdminNotificationsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, TError,void, TContext> => {

const mutationKey = getDestroyAllAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, void> = () => {


          return  destroyAllAdminNotifications()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAllAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAllAdminNotifications>>>

    export type DestroyAllAdminNotificationsMutationError = ErrorType<StandardError>


    /**
 * @summary Delete all Admin Notifications
 */
export const useDestroyAllAdminNotifications = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAllAdminNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyAllAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete the selected Admin Notifications
 */
export const destroyBulkAdminNotifications = (
    adminNotificationBulkInput: MaybeRefOrGetter<AdminNotificationBulkInput>,
 signal?: AbortSignal
) => {
      adminNotificationBulkInput = toValue(adminNotificationBulkInput);

      return axiosClient<AdminNotificationBulkResult>(
      {url: `/notifications/destroy-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminNotificationBulkInput, signal
    },
      );
    }




export const getDestroyBulkAdminNotificationsMutationKey = () => ['destroyBulkAdminNotifications'] as const;

export const getDestroyBulkAdminNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkAdminNotifications>>, TError,DestroyBulkAdminNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyBulkAdminNotifications>>, TError,DestroyBulkAdminNotificationsMutationVariables, TContext> => {

const mutationKey = getDestroyBulkAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyBulkAdminNotifications>>, DestroyBulkAdminNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  destroyBulkAdminNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyBulkAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof destroyBulkAdminNotifications>>>
    export type DestroyBulkAdminNotificationsMutationBody = AdminNotificationBulkInput
    export type DestroyBulkAdminNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyBulkAdminNotificationsMutationVariables = {data: AdminNotificationBulkInput}

    /**
 * @summary Delete the selected Admin Notifications
 */
export const useDestroyBulkAdminNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBulkAdminNotifications>>, TError,DestroyBulkAdminNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyBulkAdminNotifications>>,
        TError,
        DestroyBulkAdminNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyBulkAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark all Admin Notifications as read
 */
export const readAllAdminNotifications = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/notifications/read-all`, method: 'PUT', signal
    },
      );
    }




export const getReadAllAdminNotificationsMutationKey = () => ['readAllAdminNotifications'] as const;

export const getReadAllAdminNotificationsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllAdminNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readAllAdminNotifications>>, TError,void, TContext> => {

const mutationKey = getReadAllAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readAllAdminNotifications>>, void> = () => {


          return  readAllAdminNotifications()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadAllAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof readAllAdminNotifications>>>

    export type ReadAllAdminNotificationsMutationError = ErrorType<StandardError>


    /**
 * @summary Mark all Admin Notifications as read
 */
export const useReadAllAdminNotifications = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllAdminNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readAllAdminNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReadAllAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark the selected Admin Notifications as read
 */
export const readBulkAdminNotifications = (
    adminNotificationBulkInput: MaybeRefOrGetter<AdminNotificationBulkInput>,
 signal?: AbortSignal
) => {
      adminNotificationBulkInput = toValue(adminNotificationBulkInput);

      return axiosClient<AdminNotificationBulkResult>(
      {url: `/notifications/read-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminNotificationBulkInput, signal
    },
      );
    }




export const getReadBulkAdminNotificationsMutationKey = () => ['readBulkAdminNotifications'] as const;

export const getReadBulkAdminNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readBulkAdminNotifications>>, TError,ReadBulkAdminNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readBulkAdminNotifications>>, TError,ReadBulkAdminNotificationsMutationVariables, TContext> => {

const mutationKey = getReadBulkAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readBulkAdminNotifications>>, ReadBulkAdminNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  readBulkAdminNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadBulkAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof readBulkAdminNotifications>>>
    export type ReadBulkAdminNotificationsMutationBody = AdminNotificationBulkInput
    export type ReadBulkAdminNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReadBulkAdminNotificationsMutationVariables = {data: AdminNotificationBulkInput}

    /**
 * @summary Mark the selected Admin Notifications as read
 */
export const useReadBulkAdminNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readBulkAdminNotifications>>, TError,ReadBulkAdminNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readBulkAdminNotifications>>,
        TError,
        ReadBulkAdminNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getReadBulkAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Move the selected Admin Notifications back to the inbox
 */
export const unarchiveBulkAdminNotifications = (
    adminNotificationBulkInput: MaybeRefOrGetter<AdminNotificationBulkInput>,
 signal?: AbortSignal
) => {
      adminNotificationBulkInput = toValue(adminNotificationBulkInput);

      return axiosClient<AdminNotificationBulkResult>(
      {url: `/notifications/unarchive-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminNotificationBulkInput, signal
    },
      );
    }




export const getUnarchiveBulkAdminNotificationsMutationKey = () => ['unarchiveBulkAdminNotifications'] as const;

export const getUnarchiveBulkAdminNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveBulkAdminNotifications>>, TError,UnarchiveBulkAdminNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveBulkAdminNotifications>>, TError,UnarchiveBulkAdminNotificationsMutationVariables, TContext> => {

const mutationKey = getUnarchiveBulkAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveBulkAdminNotifications>>, UnarchiveBulkAdminNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unarchiveBulkAdminNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveBulkAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveBulkAdminNotifications>>>
    export type UnarchiveBulkAdminNotificationsMutationBody = AdminNotificationBulkInput
    export type UnarchiveBulkAdminNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnarchiveBulkAdminNotificationsMutationVariables = {data: AdminNotificationBulkInput}

    /**
 * @summary Move the selected Admin Notifications back to the inbox
 */
export const useUnarchiveBulkAdminNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveBulkAdminNotifications>>, TError,UnarchiveBulkAdminNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveBulkAdminNotifications>>,
        TError,
        UnarchiveBulkAdminNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveBulkAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark the selected Admin Notifications as unread
 */
export const unreadBulkAdminNotifications = (
    adminNotificationBulkInput: MaybeRefOrGetter<AdminNotificationBulkInput>,
 signal?: AbortSignal
) => {
      adminNotificationBulkInput = toValue(adminNotificationBulkInput);

      return axiosClient<AdminNotificationBulkResult>(
      {url: `/notifications/unread-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminNotificationBulkInput, signal
    },
      );
    }




export const getUnreadBulkAdminNotificationsMutationKey = () => ['unreadBulkAdminNotifications'] as const;

export const getUnreadBulkAdminNotificationsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadBulkAdminNotifications>>, TError,UnreadBulkAdminNotificationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unreadBulkAdminNotifications>>, TError,UnreadBulkAdminNotificationsMutationVariables, TContext> => {

const mutationKey = getUnreadBulkAdminNotificationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unreadBulkAdminNotifications>>, UnreadBulkAdminNotificationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unreadBulkAdminNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnreadBulkAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof unreadBulkAdminNotifications>>>
    export type UnreadBulkAdminNotificationsMutationBody = AdminNotificationBulkInput
    export type UnreadBulkAdminNotificationsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnreadBulkAdminNotificationsMutationVariables = {data: AdminNotificationBulkInput}

    /**
 * @summary Mark the selected Admin Notifications as unread
 */
export const useUnreadBulkAdminNotifications = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadBulkAdminNotifications>>, TError,UnreadBulkAdminNotificationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unreadBulkAdminNotifications>>,
        TError,
        UnreadBulkAdminNotificationsMutationVariables,
        TContext
      > => {
      return useMutation(getUnreadBulkAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Unread Admin Notification count
 */
export const adminNotificationsUnreadCount = (

 signal?: AbortSignal
) => {


      return axiosClient<AdminNotificationUnreadCount>(
      {url: `/notifications/unread-count`, method: 'GET', signal
    },
      );
    }




export const getAdminNotificationsUnreadCountQueryKey = () => {
    return [
    'notifications','unread-count'
    ] as const;
    }


export const getAdminNotificationsUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminNotificationsUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>> = ({ signal }) => adminNotificationsUnreadCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError, TData>
}

export type AdminNotificationsUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>>
export type AdminNotificationsUnreadCountQueryError = ErrorType<StandardError>


/**
 * @summary Unread Admin Notification count
 */

export function useAdminNotificationsUnreadCount<TData = Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Admin Notification
 */
export const destroyAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/notifications/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAdminNotificationMutationKey = () => ['destroyAdminNotification'] as const;

export const getDestroyAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAdminNotification>>, TError,DestroyAdminNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAdminNotification>>, TError,DestroyAdminNotificationMutationVariables, TContext> => {

const mutationKey = getDestroyAdminNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAdminNotification>>, DestroyAdminNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAdminNotification>>>

    export type DestroyAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyAdminNotificationMutationVariables = {id: string}

    /**
 * @summary Delete Admin Notification
 */
export const useDestroyAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAdminNotification>>, TError,DestroyAdminNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAdminNotification>>,
        TError,
        DestroyAdminNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive Admin Notification
 */
export const archiveAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/archive`, method: 'PUT', signal
    },
      );
    }




export const getArchiveAdminNotificationMutationKey = () => ['archiveAdminNotification'] as const;

export const getArchiveAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminNotification>>, TError,ArchiveAdminNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveAdminNotification>>, TError,ArchiveAdminNotificationMutationVariables, TContext> => {

const mutationKey = getArchiveAdminNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAdminNotification>>, ArchiveAdminNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAdminNotification>>>

    export type ArchiveAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ArchiveAdminNotificationMutationVariables = {id: string}

    /**
 * @summary Archive Admin Notification
 */
export const useArchiveAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminNotification>>, TError,ArchiveAdminNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveAdminNotification>>,
        TError,
        ArchiveAdminNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark Admin Notification as read
 */
export const readAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/read`, method: 'PUT', signal
    },
      );
    }




export const getReadAdminNotificationMutationKey = () => ['readAdminNotification'] as const;

export const getReadAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAdminNotification>>, TError,ReadAdminNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readAdminNotification>>, TError,ReadAdminNotificationMutationVariables, TContext> => {

const mutationKey = getReadAdminNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readAdminNotification>>, ReadAdminNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  readAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof readAdminNotification>>>

    export type ReadAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReadAdminNotificationMutationVariables = {id: string}

    /**
 * @summary Mark Admin Notification as read
 */
export const useReadAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAdminNotification>>, TError,ReadAdminNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readAdminNotification>>,
        TError,
        ReadAdminNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getReadAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Move Admin Notification back to the inbox
 */
export const unarchiveAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/unarchive`, method: 'PUT', signal
    },
      );
    }




export const getUnarchiveAdminNotificationMutationKey = () => ['unarchiveAdminNotification'] as const;

export const getUnarchiveAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveAdminNotification>>, TError,UnarchiveAdminNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveAdminNotification>>, TError,UnarchiveAdminNotificationMutationVariables, TContext> => {

const mutationKey = getUnarchiveAdminNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveAdminNotification>>, UnarchiveAdminNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unarchiveAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveAdminNotification>>>

    export type UnarchiveAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnarchiveAdminNotificationMutationVariables = {id: string}

    /**
 * @summary Move Admin Notification back to the inbox
 */
export const useUnarchiveAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveAdminNotification>>, TError,UnarchiveAdminNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveAdminNotification>>,
        TError,
        UnarchiveAdminNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark Admin Notification as unread
 */
export const unreadAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/unread`, method: 'PUT', signal
    },
      );
    }




export const getUnreadAdminNotificationMutationKey = () => ['unreadAdminNotification'] as const;

export const getUnreadAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadAdminNotification>>, TError,UnreadAdminNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unreadAdminNotification>>, TError,UnreadAdminNotificationMutationVariables, TContext> => {

const mutationKey = getUnreadAdminNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unreadAdminNotification>>, UnreadAdminNotificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unreadAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnreadAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof unreadAdminNotification>>>

    export type UnreadAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnreadAdminNotificationMutationVariables = {id: string}

    /**
 * @summary Mark Admin Notification as unread
 */
export const useUnreadAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadAdminNotification>>, TError,UnreadAdminNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unreadAdminNotification>>,
        TError,
        UnreadAdminNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getUnreadAdminNotificationMutationOptions(options), queryClient);
    }
